import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-stone flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center" data-testid="payment-cancel-card">
        <AlertCircle className="text-heritage mx-auto" size={40}/>
        <h1 className="font-display text-2xl mt-3">Payment cancelled</h1>
        <p className="text-charcoal/70 mt-2">No charge has been made. You can try again anytime.</p>
        <Link to="/partners/tourism-awards" data-testid="payment-cancel-tickets-link"
          className="inline-block mt-6 btn-primary px-6 py-2">Back to tickets</Link>
      </div>
    </div>
  );
}
